/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { COLORS } from 'colors';

export const Footer = styled.footer`
  background: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
`;

export const FooterContent = styled.div`
  padding: 2rem 1rem;
  @media (min-width: 767px) {
    padding: 2rem 3rem;
  }
`;

export const FooterGrid = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  .footer-middle {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 3rem;
  }
  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
    .footer-middle {
      gap: 5rem;
    }
  }
`;

export const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (min-width: 767px) {
    justify-content: flex-end;
  }
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const LogoBox = styled.div`
  width: 129px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LogoDesc = styled.p`
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-weight: 300;
  font-size: 16px;
  line-height: 166%;
  color: #fffcfc;
  @media (min-width: 767px) {
    justify-content: flex-end;
  }
  justify-content: center;
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
`;

export const SocialIcon = styled.span`
  color: #9ca3af;
  cursor: pointer;

  &:hover {
    color: white;
  }
`;

export const FooterHeading = styled.h3`
  margin-bottom: 1rem;
  font-weight: 700;
  font-size: 16px;
  line-height: 26.35px;
  letter-spacing: 0px;
  vertical-align: middle;
`;

export const FooterLinkList = styled.ul`
  color: #c5c5c5;
  font-weight: 400;
  font-size: 16px;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  @media (min-width: 767px) {
    flex-direction: column;
    
  }

  height: 100%;
`;

export const FooterLink = styled.li`
  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: white;
    }
  }
`;

export const EmailBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 21.47px;
`;
export const EmailHeading = styled.div`
  font-weight: 400;
  font-size: 19.04px;
  line-height: 33.4px;
  letter-spacing: 0%;
  text-transform: uppercase;
`;
export const EmailInputGroup = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #444;
  padding-bottom: 0.5rem;
`;

export const EmailInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 1rem;
  padding: 0.5rem 0;
`;

export const SubmitButton = styled.button`
  background: transparent;
  margin-left: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Newsletter = styled.div`
  margin-top: 3rem;
  padding-top: 0rem;
  border-top: none;

  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
    padding-top: 2rem;
    border-top: 1.19px solid #ffffff;
  }
`;
export const Copyright = styled.p`
  color: #9ca3af;
  font-size: 0.875rem;
  text-align: center;
`;
